<template>
  <div class="AdditionalCharges" v-if="typeof vacation.params != 'undefined'">

    <!-- ОКНО Заменить начисление. Начало -->
    <b-modal header-bg-variant="primary" header-text-variant="white" size="md"  id="modal-force-add-vacation" centered ok-disabled
             title="Обновление расчета в базе данных" cancel-title-html="Закрыть" button-size="sm">
      Расчет за указанный период уже есть в ваших данных по зарплате. Хотите обновить информацию о расчете?

      <template v-slot:modal-footer="{cancel}">
        <b-button variant="primary" size="sm" @click="addToRegisters('force')"><span class="mdi mdi-content-save"></span> Обновить расчет</b-button>
        <b-button variant="secondary" size="sm" @click="cancel()"><span class="mdi mdi-close"></span> Не обновлять
        </b-button>
      </template>
    </b-modal>
    <!-- ОКНО Заменить начисление. Конец -->

    <!-- БЛОК Панель кнопок. Начало -->
    <ControlPanel :card="false" :icon="vacation.interface.icon" :title="vacation.interface.title" :links="links" :premium="true">

      <template v-slot:left>
        <b-form-select class="mr-sm-1" size="sm" :options="modes" v-model="feature"></b-form-select>
      </template>





      <b-button class="mr-sm-1" variant="primary" size="sm" :disabled="vacation.buttons.import.disabled"
                @click="getDataVacationFromRegister()"><span class="mdi mdi-download"></span> Загрузить данные по начислениям с
        реестра
      </b-button>

      <b-button class="mr-sm-1" variant="success" size="sm" @click="addToRegisters()" :disabled="vacation.buttons.save.disabled"><span class="mdi mdi-content-save"></span> Сохранить расчет</b-button>

      <b-button variant="dark" size="sm" @click="Print('printAdditionalChargesBody', 'portrait')" :disabled="vacation.buttons.save.disabled"><span class="mdi mdi-printer"></span>
        Печать
      </b-button>

    </ControlPanel>
    <!-- БЛОК Панель кнопок. Конец -->

    <div class="container-fluid" v-if="user.registered && !user.subscribe_expired">
      <PrintAdditionalCharges :id="'printAdditionalChargesBody'" :additional="additionalFormatted"></PrintAdditionalCharges>
      <div class="row">

        <div class="col-md-7">

          <b-card :header="vacation.interface.cardTitle" class="bg-green-light border-0 mb-1" size="sm" header-bg-variant="secondary" header-text-variant="white">
            <div class="row">

              <div class="col-md-6">
                <b-form-group>
                  <SelectOrg :key="'org'" :title="['Организация', 'Организация']" :name="'orgs'"
                             :table="'reg_organizations'"
                             :fields="['name']"></SelectOrg>
                </b-form-group>

              </div>
              <div class="col-md-6">
                <b-form-group>
                  <SelectWorker :title="['Сотрудник', 'Сотрудник']"></SelectWorker>
                </b-form-group>
              </div>

              <div class="col-md-6">
                <b-form-group>
                  <Enums :type="'enum'" :name="'workweeks'" :title="'Рабочая неделя'" v-model="period.week"
                         @change="Period('week'); getCalendarInfo()"></Enums>
                </b-form-group>


              </div>

              <div class="col-md-6">
                <b-form-group>
                  <b-input-group size="sm" :prepend="vacation.interface.period">
                    <b-form-input size="sm" type="date" @change="getCalendarInfo()"
                                  v-model="vacation.params.date_from"></b-form-input>

                    <b-form-input size="sm" type="date" @change="getCalendarInfo()"
                                  v-model="vacation.params.date_to"></b-form-input>
                  </b-input-group>
                </b-form-group>
              </div>




              <div class="col-md-6">
                <b-form-group>
                  <b-form-checkbox value="1" unchecked-value="0" @change="getCalendarInfo()"
                                   v-model="vacation.params.more_than_year">Трудоустроен более 1
                    года назад
                  </b-form-checkbox>
                </b-form-group>
              </div>

              <div class="col-md-6">
                <template v-if="vacation.params.more_than_year == 0">
                  <b-input-group size="sm" prepend="Дата принятия на работу">
                    <b-form-input size="sm" type="date" @change="getCalendarInfo()"
                                  v-model="vacation.params.date_employment"></b-form-input>
                  </b-input-group>
                </template>
              </div>
            </div>
          </b-card>

          <b-card header="Результат расчета" class="bg-yellow-light border-0 mb-2" size="sm" header-bg-variant="secondary" header-text-variant="white" body-class="bg-yellow-light">
            <div class="row">
              <div class="col-md-4">
                <b-form-group>
                  <b-form-input size="sm" type="number" v-model="vacation.params.daily_sum"></b-form-input>
                  <small class="form-text text-muted">Средний дневной заработок</small>
                </b-form-group>
              </div>
              <div class="col-md-4">
                <b-form-group>
                  <b-form-input size="sm" type="number" v-model="vacation.params.days.work" readonly></b-form-input>
                  <small class="form-text text-muted">{{vacation.interface.count}}</small>
                </b-form-group>
              </div>
              <div class="col-md-4">
                <b-form-group>
                  <b-form-input size="sm" type="number" v-model="vacation.result" readonly></b-form-input>
                  <small class="form-text text-muted">{{vacation.interface.amount}}</small>
                </b-form-group>
              </div>

            </div>

            <table v-if="vacation.result > 0" class="table table-sm table-bordered table-yellow">
              <tbody>
              <tr>
                <th>Дата</th>
                <th>Дней</th>
                <th v-if="feature=='hospital'">Предел 15/25 МРП</th>
                <th>Сумма</th>
              </tr>
              <template v-for="(item, index) in vacation.daysinmonth">
                <tr :key="index">
                  <td>{{item.name}}</td>
                  <td>{{item.days}}</td>
                  <td v-if="feature=='hospital'" class="text-center"><span v-if="item.max">ДА</span></td>
                  <td>{{item.amount}}</td>
                </tr>
              </template>
              </tbody>
            </table>

          </b-card>

          <div class="alert alert-danger" v-if="vacation.params.days.work == 0">
            Заполните правильно даты раздела <strong>{{vacation.interface.period}}</strong>
          </div>


          <div class="alert alert-danger" v-if="vacation.params.days.work > 0 && vacation.params.sum == 0">
            Заполните начисления и отработанные дни за предыдущие месяцы в таблице справа <template v-if="user.subscribe_type == 'premium'">или загрузите эти данные из реестра, нажав на кнопку сверху</template>
          </div>


        </div>
        <div class="col-md-5">
          <b-card header="Календарь отработанных месяцев" class="mb-1 border-0 bg-green-light" size="sm" header-bg-variant="secondary" header-text-variant="white" >

            <div v-if="params.trigger" class="mb-3">

              <div class="row">

                <div class="col-12">
                  <div class="mb-3">
                    <b-form-select size="sm" :options="params.indexedMonths" v-model="params.indexTo" class="mr-1" @change="selectIndexationMonth(params.indexTo)"></b-form-select>
                    <small class="form-text text-muted">Если в отработанном периоде у работника была индексация оклада, укажите месяц, в котором производилась индексация. </small>
                  </div>
                </div>

                <template v-if="params.indexTo !== ''">
                  <div class="col-5">
                    <div class="mb-3">
                      <b-form-input type="number" size="sm" v-model="params.oldSum"></b-form-input>
                      <small class="form-text text-muted">Сумма оклада до индексации</small>
                    </div>
                  </div>
                  <div class="col-5">
                    <div class="mb-3">
                      <b-form-input type="number" size="sm" v-model="params.newSum"></b-form-input>
                      <small class="form-text text-muted">Сумма оклада после индексации</small>
                    </div>
                  </div>

                  <div class="col-2">
                    <div class="mb-3">
                      <b-form-input size="sm" readonly v-model="params.ratio"></b-form-input>
                      <small class="form-text text-muted">Коэффициент</small>
                    </div>
                  </div>

                  <div class="col-12">
                    <b-btn size="sm" class="btn-block" @click="setRatio">Установить коэффициенты в таблицу</b-btn>
                  </div>

                </template>

              </div>

            </div>
            <table class="table table-sm table-bordered table-green">
              <tbody>
              <tr>
                <th colspan="2"></th>
                <th>Месяц</th>
                <th width="18%">Отр.дней</th>
                <th width="18%">Календ.дней</th>
                <th width="18%">Начисление</th>
                <th width="15%">Коэфф.</th>
              </tr>


              <template v-for="(item, index) in vacation.months">
                <tr :key="index">
                  <td class="text-center">
                    <span v-if="item.downloaded" class="mdi mdi-download text-primary" v-b-tooltip
                       title="Данные загружены из реестра зарплаты"></span>
                  </td>
                  <td>
                    <span v-if="vacation.months[index].days.fact > 0 && vacation.months[index].sum > 0" class="mdi mdi-chevron-double-down text-success" v-b-tooltip
                       title="Есть отработанные дни и есть начисление"></span>
                    <span v-if="vacation.months[index].days.fact == 0 && vacation.months[index].sum == 0" class="mdi mdi-chevron-double-down text-info" v-b-tooltip
                       title="Нет отработанных дней и начислений. В расчете не участвует"></span>
                    <span v-if="vacation.months[index].days.fact > 0 && vacation.months[index].sum == 0" class="mdi mdi-chevron-down text-danger" v-b-tooltip
                       title="Есть отработанные дни но нет начисления"></span>
                    <span v-if="vacation.months[index].days.fact == 0 && vacation.months[index].sum > 0" class="mdi mdi-chevron-down text-danger" v-b-tooltip
                       title="Есть начисления, но нет отработанных дней"></span>
                  </td>
                  <td>
                    <b-form-input type="text" size="sm" v-model="item.name" :disabled="item.disabled" readonly></b-form-input>
                  </td>
                  <td>
                    <b-form-input type="number" size="sm" v-model="item.days.fact"
                                  :disabled="item.disabled"></b-form-input>
                  </td>
                  <td>
                    <b-form-input type="number" size="sm" v-model="item.days.calendar"
                                  :disabled="item.disabled" readonly></b-form-input>
                  </td>
                  <td>
                    <b-form-input type="number" size="sm" v-model="item.sum" :disabled="item.disabled"></b-form-input>
                  </td>
                  <td>
                    <b-form-input type="number" step=".01" size="sm" v-model="item.ratio"
                                  :disabled="item.disabled"></b-form-input>
                  </td>
                </tr>
              </template>

              <tr>
                <th colspan="3">ИТОГО:</th>

                <td><b-form-input size="sm" type="number" v-model="vacation.params.days.fact" readonly></b-form-input></td>
                <td><b-form-input size="sm" type="number" v-model="vacation.params.days.calendar" readonly></b-form-input></td>
                <td colspan="2"><b-form-input size="sm" type="number" v-model="vacation.params.sum" readonly></b-form-input></td>
              </tr>
              </tbody>
            </table>
          </b-card>
        </div>
      </div>
    </div>


      <Premium v-else />

  </div>
</template>

<script>

import ControlPanel from "@/components/base/ControlPanel";
import SelectOrg from "@/components/base/SelectOrg";
import SelectWorker from "@/components/base/SelectWorker";
import Enums from "@/components/base/Enums";
import PrintAdditionalCharges from "@/components/print/AdditionalCharges";
import {mapGetters} from "vuex";
import Premium from "@/components/base/Premium.vue";

export default {
  name: 'Additionalcharges',
  components: {
      Premium,
    ControlPanel,
    SelectOrg,
    SelectWorker,
    Enums,
    PrintAdditionalCharges
  },

  data: function () {
    return {
      links: [
        {name: 'Сохраненный список начислений отпускных/больничных/компенсаций', link: '/salary/additionalcalcs/', icon: 'mdi mdi-view-list'},
        {name: 'Калькулятор заработной платы', link: '/', icon: 'mdi mdi-calculator'},
      ],
      force: false,
      feature: 'vacation',
      modes: [
        {text: 'Расчет отпускных', value: 'vacation'},
        {text: 'Расчет дополнительных отпускных', value: 'additionalvacation'},
        {text: 'Расчет компенсации при увольнении', value: 'compensationvacation'},
        {text: 'Расчет больничных', value: 'hospital'}
      ],
      vacation: {},
      period: {
        month: '01',
        year: new Date().getFullYear(),
        week: '40_5',
        days: 0,
        hours: 0
      },
      params: {
        trigger: false,
        indexedMonths: [],
        indexTo: '',
        oldSum: 0,
        newSum: 0,
        ratio: 1
      }
    }
  },
  methods: {
    selectIndexationMonth: function (index) {
      if (index == '') {
        this.params.newSum = 0
        this.params.oldSum = 0
        this.vacation.months.forEach((item, i) => {
          if (!item.disabled) {
            this.vacation.months[i].ratio = 1
          }
        })

      }
      else {
        this.params.newSum = this.vacation.months[index].sum
        this.params.oldSum = this.vacation.months[index+1].sum
      }

    },

    setRatio: function () {

      this.vacation.months.forEach((item, i) => {
        if (!item.disabled && i > this.params.indexTo) {
          this.vacation.months[i].ratio = this.params.ratio
        }
      })
    },

    addToRegisters: function(mode){
      this.$store.commit('wait', {state: true, name: 'Сохранение расчёта дополнительных начислений'});
      this.$http
          .post(this.$apiold, {
            task: 'salary-add-to-additional-charges',
            mode: mode,
            org: this.org,
            worker: this.worker,
            feature: this.feature,
            period: this.period,
            vacation: this.vacation
          })
          .then(response => {
            this.$store.commit('wait', {state: false});
            var result = response.data.result;

            // Открываем окно
            if (response.data.force) {
              this.$bvModal.show('modal-force-add-vacation');
            }
            else {
              this.$bvModal.hide('modal-force-add-vacation');
            }

            // Сообщения
            this.$store.commit('alert', response.data.messages);
            result

            if (!response.data.error) {
              // Регистрируем изменение для обновления реестра
              this.$store.commit('change');
            }

          });
    },
    additionalCharges: function (mode) {
      this.vacation = {
        title: '',
        buttons: {
          import: {
            disabled: true
          },
          save: {
            disabled: true
          }
        },
        daysinmonth: [],
        result: 0,
        params: {
          type: 1,
          more_than_year: 1,
          date_employment: '',
          date_from: '',
          date_to: '',
          sum: 0,
          daily_sum: 0,
          days: {
            calendar: 0,
            fact: 0,
            work: 0,
          }
        },
        months: []
      }
      switch (mode) {
        default:

          break;
        case 'vacation':
          this.vacation.interface = {
            title: 'Расчет отпускных',
            icon: 'mdi mdi-tent',
            cardTitle: 'Организация, сотрудник, период отпуска',
            period: 'Период отпуска',
            period2: 'в периоде отпуска',
            count: 'Количество рабочих дней в периоде отпуска',
            amount: 'Общая сумма отпускных'
          };

          break;
        case 'additionalvacation':
          this.vacation.interface = {
            title: 'Расчет дополнительных отпускных',
            icon: 'mdi mdi-tent',
            cardTitle: 'Организация, сотрудник, период дополнительного отпуска',
            period: 'Период отпуска',
            period2: 'в периоде отпуска',
            count: 'Количество рабочих дней в периоде отпуска',
            amount: 'Общая сумма отпускных'
          }

          break;
        case 'compensationvacation':
          this.vacation.interface = {
            title: 'Расчет компенсации при увольнении',
            icon: 'mdi mdi-briefcase',
            cardTitle: 'Организация, сотрудник, период неиспользованного отпуска',
            period: 'Период отпуска',
            period2: 'в периоде неиспользованного отпуска',
            count: 'Количество рабочих дней в периоде отпуска',
            amount: 'Общая сумма отпускных'
          }
          break;
        case 'hospital':
          this.vacation.interface = {
            title: 'Расчет больничных',
            icon: 'mdi mdi-account-injury',
            cardTitle: 'Организация, сотрудник, период больничных',
            period: 'Период больничных',
            period2: 'в периоде больничных',
            count: 'Количество рабочих дней в больничном периоде',
            amount: 'Общая сумма больничных'
          }
          break;
      }
    },

    // МЕТОД Получить данные для расчета отпускных из регистра
    getDataVacationFromRegister: function () {

      this.$store.commit('wait', {state: true, name: 'Получение данных для расчета отпуска из справочников'});
      this.$http
          .post(this.$apiold, {
            task: 'salary-get-data-vacation-from-register',
            months: this.vacation.months,
            worker: this.worker
          })
          .then(response => {
            this.$store.commit('wait', {state: false});
            this.vacation.months = response.data.result.months;

            this.$store.commit('user', response.data.user);

            // Сообщения
            this.$store.commit('alert', response.data.messages);
          });
    },

    // МЕТОД Получить суммы отпускных
    getVacationSums: function () {
      this.vacation.params.days.fact = 0;
      this.vacation.params.days.calendar = 0;
      this.vacation.params.sum = 0;
      this.vacation.params.daily_sum = 0;
      this.vacation.result = 0;

      for (var i = 0; i < this.vacation.months.length; i++) {
        this.vacation.months[i].days.fact == '' ? this.vacation.months[i].days.fact = 0 : this.vacation.months[i].days.fact = parseInt(this.vacation.months[i].days.fact);
        this.vacation.months[i].days.calendar == '' ? this.vacation.months[i].days.calendar = 0 : this.vacation.months[i].days.calendar = parseInt(this.vacation.months[i].days.calendar);
        this.vacation.months[i].sum == '' ? this.vacation.months[i].sum = 0 : this.vacation.months[i].sum = parseInt(this.vacation.months[i].sum);
        this.vacation.params.days.fact += this.vacation.months[i].days.fact;
        this.vacation.params.days.calendar += this.vacation.months[i].days.calendar;
        this.vacation.params.sum += (this.vacation.months[i].sum * +this.vacation.months[i].ratio);
        if (this.vacation.params.days.fact != 0) {
          //this.vacation.params.daily_sum = Math.floor(this.vacation.params.sum / this.vacation.params.days.fact);
          this.vacation.params.daily_sum = (this.vacation.params.sum / this.vacation.params.days.fact).toFixed(2);

        }
      }
    },

    // МЕТОД Получить данные календаря
    getCalendarInfo: function () {
      this.$store.commit('wait', {state: true, name: 'Загрузка данных календаря'});
      this.$http
          .post(this.$apiold, {
            task: 'salary-get-calendar-info',
            vacation: this.vacation,
            period: this.period
          })
          .then(response => {
            this.$store.commit('wait', {state: false});

            this.$store.commit('user', response.data.user);

            this.vacation.months = response.data.result.months;

            this.params.indexTo = ''

            this.vacation.daysinmonth = response.data.result.daysinmonth;
            this.vacation.buttons.import.disabled = response.data.result.button_disabled;
            this.vacation.params.days.work = response.data.result.days;

            // Сообщения
            this.$store.commit('alert', response.data.messages);
          })
    },

    // МЕТОД Период
    Period: function (mode) {
      this.$store.commit('wait', {state: true, name: 'Загрузка данных периода'});
      this.$http
          .post(this.$apiold, {
            task: 'salary-period',
            period: this.period,
            mode: mode
          })
          .then(response => {
            this.$store.commit('wait', {state: false});
            this.$store.commit('user', response.data.user);
            var result = response.data.result;
            this.period.days = result.period.days;
            this.period.hours = result.period.hours;

            this.additionalCharges(this.feature)

          });
    },
    calcResult: function () {
      this.vacation.params.sum == '' ? this.vacation.params.sum = 0 : this.vacation.params.sum = parseFloat(this.vacation.params.sum);
      this.vacation.params.daily_sum == '' ? this.vacation.params.daily_sum = 0 : this.vacation.params.daily_sum = parseFloat(this.vacation.params.daily_sum);
      this.vacation.params.days.work == '' ? this.vacation.params.days.work = 0 : this.vacation.params.days.work = parseFloat(this.vacation.params.days.work);
      this.vacation.params.days.fact == '' ? this.vacation.params.days.fact = 0 : this.vacation.params.days.fact = parseFloat(this.vacation.params.days.fact);
      this.vacation.params.days.calendar == '' ? this.vacation.params.days.calendar = 0 : this.vacation.params.days.calendar = parseFloat(this.vacation.params.days.calendar);

      //this.vacation.result = this.vacation.params.daily_sum * this.vacation.params.days.work;

      var _this = this;
      this.vacation.daysinmonth.forEach(function (value, index, array){
        value
        index
        array
        _this.vacation.daysinmonth[index]['amount'] = Math.round((_this.vacation.daysinmonth[index]['days'] * _this.vacation.params.daily_sum)) ;
        //_this.vacation.daysinmonth[index]['max'] = false;

        // Если больничные, то не более 15 МРП

        if (_this.feature == 'hospital' && _this.vacation.daysinmonth[index]['amount'] > 15 * _this.vacation.daysinmonth[index]['mrp'] && new Date(_this.vacation.daysinmonth[index].date) < new Date('2023-07-01')) {
          _this.vacation.daysinmonth[index]['amount'] = 15 * _this.vacation.daysinmonth[index]['mrp'];
          _this.vacation.daysinmonth[index]['max'] = true;
        }

        if (_this.feature == 'hospital' && _this.vacation.daysinmonth[index]['amount'] > 25 * _this.vacation.daysinmonth[index]['mrp'] && new Date(_this.vacation.daysinmonth[index].date) >= new Date('2023-07-01')) {
          _this.vacation.daysinmonth[index]['amount'] = 25 * _this.vacation.daysinmonth[index]['mrp'];
          _this.vacation.daysinmonth[index]['max'] = true;
        }

      });

      this.vacation.result = this.getAmountField(this.vacation.daysinmonth, 'amount');

      // Тут расчет отпускных по месяцам


      if (parseInt(this.vacation.result) == 0 || this.vacation.result == '') {
        this.vacation.buttons.export = true;
      } else {
        this.vacation.buttons.export = false;
      }
    }
  },
  created: function () {
    this.setOrgs();
    this.Period();
  },
  computed: {
    ...mapGetters({
      org: 'org',
      worker: 'worker',
      user: "user"
    }),

    additionalFormatted: {
      get() {
        return {
          feature: this.feature,
          org: this.org,
          worker: this.worker,
          interface: this.vacation.interface,
          params: this.vacation.params,
          months: this.vacation.months,
          daysinmonth: this.vacation.daysinmonth,
          result: this.vacation.result
        }
      }
    }
  },

  watch: {
    feature: {
      handler: function () {
        this.additionalCharges(this.feature);
      }
    },
    vacation: {
      handler: function () {

        console.log('Результат' + this.vacation.result);

        this.calcResult();

        if (this.vacation.result > 0) {
          this.vacation.buttons.save.disabled = false;
        }
        else {
          this.vacation.buttons.save.disabled = true;
        }

      },
      deep: true
    },
    'vacation.months': {
      handler: function (val) {


        if (val.length > 0) {
          val.forEach((item) => {
            if (!item.disabled) {
              this.params.trigger = true
            }
          })
        }
        else {
          this.params.trigger = false
        }

        this.params.indexedMonths = []
        this.params.indexedMonths.push({ text: 'Индексация за отработанный период не производилась', value: ''})


        val.forEach((item, i) => {
          if (!item.disabled && item.sum == 0) {
           this.params.trigger = false
          }
          if (!item.disabled) {
            this.params.indexedMonths.push({ text: item.name, value: i})
          }
        })


        this.getVacationSums();
      },
      deep: true
    },

    'params': {


      handler: function() {
        console.log('indexTo=' + this.params.indexTo)
        if (this.params.indexTo !== '' && this.params.newSum > 0 && this.params.oldSum > 0) {
          this.params.ratio = (this.params.newSum / this.params.oldSum).toFixed(6)
        }
        else {
          this.params.ratio = 1
        }


      },
      deep: true
    },


  }
};
</script>
